import { MaterialReactTable } from "material-react-table";

import ViewSaveDialog from "../ViewSaveDialog";
import { MarkJobReadyPopover } from "../MarkJobReadyPopover";

import type { Props } from "./JobsDashboardTable.types";
import { useJobsDashboardTableViewModel } from "./JobsDashboardTable.vm";
import { DashboardToolbar } from "./components/DashboardToolbar";
import { DownloadMenu } from "./components/DownloadMenu";
import { MobileMenu } from "./components/MobileMenu";

export function JobsDashboardTable(props: Props) {
	const vm = useJobsDashboardTableViewModel(props);

	const downloadCtx = vm.getDownloadMenuContext();

	return (
		<>
			<DashboardToolbar vm={vm} drawerOpen={props.drawerOpen} setDrawerOpenState={props.setDrawerOpenState} />

			<MaterialReactTable table={vm.table} />
			<ViewSaveDialog {...vm.inputDialogState} />
			<MarkJobReadyPopover
				open={vm.markJobsReadyVisible}
				jobs={vm.jobs.filter((job) => !job.dateFieldReady)}
				initialSelectedJobs={vm.markJobsReadyVisible ? vm.unreadySelectedJobs : []}
				setLoading={props.setLoading}
				onSuccess={vm.refreshJobs}
				setOpen={(open) => vm.setMarkJobsReadyVisible(open)}
			/>

			<DownloadMenu vm={vm} downloadCtx={downloadCtx} />
			<MobileMenu vm={vm} />
		</>
	);
}
